import { SendSms } from '@features/ForestOwner/Search/Overview/SendSms'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/$forestownerId/sendSMS/')({
  component: SendSms,
  staticData: {
    breadcrumb: 'Send SMS',
  },
})
